type TicketQrModalProps = {
  open: boolean
  onClose: () => void
  title: string
  qrImageUrl?: string | null
  qrPayload?: Record<string, any> | null
  receiptHash?: string | null
  receiptStatus?: string | null
  pendingMessage?: string | null
  linksAvailable?: boolean
  onRefreshReceipt?: (() => void) | null
  refreshingReceipt?: boolean
}

export default function TicketQrModal({
  open,
  onClose,
  title,
  qrImageUrl,
  qrPayload,
  receiptHash,
  receiptStatus,
  pendingMessage,
  linksAvailable = true,
  onRefreshReceipt = null,
  refreshingReceipt = false,
}: TicketQrModalProps) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 p-4" onClick={onClose}>
      <div className="w-full max-w-md rounded-2xl border border-white/15 bg-neutral-950 p-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-sm uppercase tracking-[0.12em] text-white/60">Ticket QR</div>
            <div className="mt-1 text-base font-semibold text-white">{title}</div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-white/15 px-2 py-1 text-xs text-white/80 hover:bg-white/10"
          >
            Close
          </button>
        </div>
        <div className="mt-4 flex justify-center">
          {qrImageUrl ? (
            <img src={qrImageUrl} alt="Ticket QR code" className="h-56 w-56 rounded-lg border border-white/10 bg-white p-2" />
          ) : (
            <div className="h-56 w-56 rounded-lg border border-dashed border-white/20 text-xs text-white/60 flex items-center justify-center">
              QR unavailable
            </div>
          )}
        </div>
        <div className="mt-4 space-y-2 text-xs">
          <div className="text-white/75">
            Receipt:{' '}
            {receiptStatus === 'anchored' ? (
              <span className="text-emerald-300 font-semibold">Verified</span>
            ) : receiptStatus === 'pending' ? (
              <span className="text-amber-200 font-semibold">Pending</span>
            ) : receiptStatus === 'failed' ? (
              <span className="text-rose-300 font-semibold">Failed</span>
            ) : (
              <span className="text-rose-300 font-semibold">{receiptStatus || 'Unknown'}</span>
            )}
          </div>
          <div className="break-all text-white/60">Hash: {receiptHash || 'Unavailable'}</div>
          {receiptStatus === 'pending' && pendingMessage ? (
            <div className="rounded-md border border-amber-400/30 bg-amber-500/10 px-2 py-1 text-amber-100">{pendingMessage}</div>
          ) : null}
          {receiptStatus === 'pending' && onRefreshReceipt ? (
            <button
              type="button"
              onClick={onRefreshReceipt}
              className="rounded-md border border-white/15 bg-white/5 px-2 py-1 text-[11px] font-semibold text-white/85 hover:bg-white/10"
              disabled={refreshingReceipt}
            >
              {refreshingReceipt ? 'Refreshing...' : 'Refresh receipt'}
            </button>
          ) : null}
          {!linksAvailable ? (
            <div className="rounded-md border border-rose-400/30 bg-rose-500/10 px-2 py-1 text-rose-100">
              Links unavailable (misconfigured NOTIFICATIONS_WEB_BASE_URL).
            </div>
          ) : null}
          {qrPayload ? <pre className="max-h-28 overflow-auto rounded-lg bg-black/40 p-2 text-[11px] text-white/55">{JSON.stringify(qrPayload, null, 2)}</pre> : null}
        </div>
      </div>
    </div>
  )
}
